import React, { useEffect, useContext, useState } from 'react';
import _ from 'lodash';
import equal from 'fast-deep-equal/es6';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../../context/Profile.context';
import { editControls, routes, verifiedSectionKeys } from '../../../constants';
import { testIds } from '../../../constants/testIds';
import { withRouter } from '../../WithRouter';
import SectionNextActions from '../../SectionNextActions';
import { Box, Button, Card, CardContent, CardHeader, CardTitle } from '@otcmarketsgroup/otcm-ui-lib';
import { Building2, Pencil, X } from 'lucide-react';
import IncorporationHistory from './IncorporationHistory';
import CompanyNameHistory from './CompanyNameHistory';
import GeneralInformation from './GeneralInformation';
import FilingInformation from './FilingInformation';
import OrganizationalStage from './OrganizationalStage';

const CompanyInformationForm = ({ params: { symbol }, saveApplication }) => {
  const [profileState] = useContext(ProfileContext);
  const profileData = profileState.profile;
  const backupProfile = profileState.backupProfile;
  const showVerifyBox = !profileState.readOnly;
  useEffect(() => {
    const isIncorporationChange = !equal({ ...backupProfile.companyInfo.incorporationInfo }, { ...profileData.companyInfo.incorporationInfo });
    const isCompNameChange = !equal({ ...backupProfile.companyInfo.companyNameHistoryList }, { ...profileData.companyInfo.companyNameHistoryList });

    if (isIncorporationChange || isCompNameChange) {
      saveApplication();
    }
  }, [backupProfile.companyInfo.companyNameHistoryList, backupProfile.companyInfo.incorporationInfo, profileData.companyInfo.companyNameHistoryList, profileData.companyInfo.incorporationInfo, saveApplication]);

  return <Box display='flex' flexDirection='column' gap={2} data-testid={testIds.companyInfo.section}>
    <Card>
      <CardHeader>
        <CardTitle icon={<Building2 />}>Company Information</CardTitle>
      </CardHeader>
      <CardContent>
        <Box display='flex' flexDirection='column' gap={2}>
          <GeneralInformation />
          <IncorporationHistory />
          <CompanyNameHistory />
          <FilingInformation />
          <OrganizationalStage />
        </Box>
      </CardContent>
    </Card>
    <SectionNextActions
      readOnly={!showVerifyBox}
      section={verifiedSectionKeys.COMPANY_INFO}
      linkTo={`${routes.PROFILE_PREFIX}/${symbol}/${routes.CONTACT_INFO}`}
      verifyBoxTestId={testIds.companyInfo.verifyBox}
      nextBtnTestId={testIds.companyInfo.nextBtn}
    />
  </Box>;
};

CompanyInformationForm.propTypes = {
  params: PropTypes.shape({
    symbol: PropTypes.string
  }),
  saveApplication: PropTypes.func
};

export default withRouter(CompanyInformationForm);
